'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'bookmark';
var width = 384;
var height = 512;
var aliases = [128278,61591];
var unicode = 'f02e';
var svgPathData = ['M32 32l0 424.3 143.9-83.9L192 363l16.1 9.4L352 456.3 352 32 32 32z', 'M192 363l16.1 9.4L352 456.3 352 32 32 32l0 424.3 143.9-83.9L192 363zM32 493.3L0 512l0-37L0 32 0 0 32 0 352 0l32 0 0 32 0 443 0 37-32-18.7L192 400 32 493.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;